export const recommendProductBannerContent = {
    title: {
        default: <>Рекомендуйте продукт своим клиентам и&nbsp;получайте вознаграждение</>,
        connectedStatus: 'Рекомендуйте этот продукт своим клиентам',
    },
    defaultText: 'Присоединяйтесь к партнёрской программе МТС Агенты',
    buttonText: {
        becomeAgent: 'Стать агентом',
        newLead: 'Новый лид',
        referralLink: 'Реферальная ссылка',
    },
};
